exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "footer {\n    padding: 39px 0 32px;\n    font-size: 14px;\n    background: url(\"http://localhost:3000/img/footer-lines.png\") top left repeat-x #f1f1f1;\n}\nfooter p {\n    margin: 16px 0 32px;\n    font-size: 14px;\n    line-height: 24px;\n}\nfooter h3 {\n    margin-bottom: 16px;\n    font-size: 16px;\n    font-weight: bold;\n    color: var(--text-color-darker);\n}\nfooter a {\n    color: var(--text-color-dark);\n}\nfooter a:hover {\n    color: var(--text-color-dark);\n}\nfooter li {\n    margin-top: 16px;\n    list-style: none;\n    font-size: 14px;\n}\n\n.social a {\n    margin-right: 16px;\n}\n", ""]);

// exports
